'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _pickupLocatorStyle = require('./pickupLocatorStyle.scss');

var _pickupLocatorStyle2 = _interopRequireDefault(_pickupLocatorStyle);

var _fluxWrapper = require('../../higherOrder/pickupLocations/fluxWrapper');

var _fluxWrapper2 = _interopRequireDefault(_fluxWrapper);

var _ResponsiveLayoutSelection = require('../ResponsiveLayoutSelection');

var _ResponsiveLayoutSelection2 = _interopRequireDefault(_ResponsiveLayoutSelection);

var _Mobile = require('./Mobile');

var _Mobile2 = _interopRequireDefault(_Mobile);

var _Desktop = require('./Desktop');

var _Desktop2 = _interopRequireDefault(_Desktop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PickupLocator = function (_React$Component) {
  (0, _inherits3.default)(PickupLocator, _React$Component);

  function PickupLocator() {
    (0, _classCallCheck3.default)(this, PickupLocator);
    return (0, _possibleConstructorReturn3.default)(this, (PickupLocator.__proto__ || (0, _getPrototypeOf2.default)(PickupLocator)).apply(this, arguments));
  }

  (0, _createClass3.default)(PickupLocator, [{
    key: 'render',
    value: function render() {
      var Mobile = (0, _fluxWrapper2.default)((0, _reactCssModules2.default)(_pickupLocatorStyle2.default)(_Mobile2.default));
      var Desktop = (0, _fluxWrapper2.default)((0, _reactCssModules2.default)(_pickupLocatorStyle2.default)(_Desktop2.default));

      return _react2.default.createElement(_ResponsiveLayoutSelection2.default, {
        small: _react2.default.createElement(Mobile, this.props),
        large: _react2.default.createElement(Desktop, this.props),
        maxSize: 783
      });
    }
  }]);
  return PickupLocator;
}(_react2.default.Component);

exports.default = PickupLocator;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/PickupLocator/index.js
// module id = 2496
// module chunks = 0